import { cn } from '@/lib/utils'
import type { TaskStatus } from '@/lib/types'

interface StatusBadgeProps {
  status: TaskStatus
  size?: 'sm' | 'default'
}

export function StatusBadge({ status, size = 'default' }: StatusBadgeProps) {
  const getStatusStyles = (status: TaskStatus) => {
    switch (status) {
      case 'running':
        return 'bg-slate-800 text-slate-100 border-slate-600'
      case 'paused':
        return 'bg-slate-900 text-amber-300 border-amber-800'
      case 'stopped':
        return 'bg-slate-900 text-slate-400 border-slate-700'
      case 'complete':
        return 'bg-slate-900 text-green-300 border-green-800'
      case 'error':
        return 'bg-slate-900 text-red-300 border-red-800'
      default:
        return 'bg-slate-950 text-slate-500 border-slate-800'
    }
  }

  return (
    <span
      className={cn(
        'inline-flex items-center rounded border font-medium uppercase tracking-normal',
        getStatusStyles(status),
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      )}
    >
      {status}
    </span>
  )
}
